import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';
import useWorkshopVerificationRequestQuery from 'hooks/useWorkshopVerificationRequestQuery';

type ManuallyUploadPoaVariables = {
  power_of_attorney_uuid: string;
};

export function useManuallyUploadPoaMutation(id: number | undefined) {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<InferFetchData<typeof manuallyUploadPoa>, ApiError, ManuallyUploadPoaVariables>({
    mutationKey: getKey(id),
    mutationFn: (variables) => throwOnError(manuallyUploadPoa(apiClient, id!, variables)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: useWorkshopVerificationRequestQuery.getKey(id) });
      queryClient.invalidateQueries({ queryKey: ['Tasks'] });
    },
  });
}

function manuallyUploadPoa(apiClient: ApiClient, id: number, body: ManuallyUploadPoaVariables) {
  return apiClient.POST('/op/v2/workshop-verification-request/{id}/power-of-attorney', {
    params: { path: { id } },
    body,
  });
}

function getKey(id: number | undefined) {
  return ['ManuallyUploadPoa', id] as const;
}

useManuallyUploadPoaMutation.getKey = getKey;
